export const REQUEST_HOME_BANNER = "REQUEST_HOME_BANNER";
